exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lin{display:inline-block;width:0.05333rem;height:0.18667rem;border-radius:0.02667rem;background:#4dc78c;margin-right:0.13333rem}.border-r6{border-radius:0.08rem}.border{border:0.01333rem solid #ebeef5}.border-b{border-bottom:0.01333rem solid #ebeef5}", ""]);

// exports
